<template>
  <ModalPhoto
    :openModal="Boolean(schedule)"
    :initialPhoto="schedule?.patient_photo || null"
    @onSaveClick="savePhoto"
    @onClearClick="savePhoto"
    @onClose="$emit('close')"
  />
</template>

<script>
import http from '../../../helpers/http';
import Alert from '../../../helpers/alert';
import str from '../../../helpers/str';
import ModalPhoto from '../../../components/ModalPhoto.vue';

export default {
  name: 'SchedulePatientPhotoModal',
  components: { ModalPhoto },
  props: {
    schedule: { type: Object, default: null },
  },
  emits: ['close', 'saved'],
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  methods: {
    savePhoto(photo) {
      if (!this.schedule?.id_patient) {
        this.$emit('close');
        return;
      }

      const formData = new FormData();
      formData.append('_method', 'put');
      if (photo) {
        formData.append('patient_photo', str.convertFileToBase64(photo.split(',')[1]));
      }

      http({
        method: 'post',
        url: `/places/${this.place.id_place}/patients/${this.schedule.id_patient}`,
        data: formData,
      }).then(() => {
        this.$emit('saved');
        this.$emit('close');
        Alert.toastSuccess('Foto armazenada com sucesso!');
      }).catch((error) => {
        Alert.toastError(error.response?.data || 'Não foi possível salvar a foto.');
      });
    },
  },
};
</script>
